<template>
  <v-dialog
    v-model="visible"
    max-width="500px"

    @click:outside="close"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ $t('price') }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-menu
                  v-model="menus.active_from"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.active_from"
                      :label="$t('valid_from')"
                      prepend-icon="event"
                      readonly
                      dense
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    :value="editedItem.active_from"
                    first-day-of-week="1"
                    @input="val => editedItem.active_from = val"
                  >
                    <v-spacer />

                    <v-btn
                      text
                      color="primary"
                      @click="() => {
                        menus.active_from = false
                      }"
                    >
                      {{ $t('ok') }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="4"
              >
                <v-checkbox
                  v-model="editedItem.active"

                  class="mt-0"
                  dense
                  :label="$t('active')"
                />
              </v-col>

              <v-col
                cols="4"
              >
                <v-checkbox
                  v-model="editedItem.supports_app"

                  class="mt-0"
                  dense
                  :label="$t('app_support')"
                />
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="editedItem.has_insurance"

                  class="mt-0"
                  dense
                  :label="$t('insurance')"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <base-paginated-select
                  :selected="editedItem.products"
                  endpoint="products-select"
                  multiple
                  :label="$t('products')"
                  item-text="title"
                  selected-item-text="title"
                  @value-change="val => {
                    editedItem.products = val;
                    calculatePrice(editedItem)
                  }"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <base-paginated-select
                  :selected="editedItem.carrier_product_services"
                  endpoint="carrier-product-services"
                  multiple
                  :label="$t('carrier_product_services')"
                  item-text="slug"
                  selected-item-text="slug"
                  :rules="rules"
                  @value-change="val => {
                    editedItem.carrier_product_services = val;
                    calculatePrice(editedItem)
                  }"
                />
              </v-col>
              <v-col cols="6">
                <base-paginated-select
                  :selected="editedItem.transit"
                  endpoint="transit"
                  :label="`${$t('transit')}`"
                  item-text="title"
                  selected-item-text="title"
                  @value-change="v => {
                    editedItem.transit = v;
                    editedItem.transit_product_id = v ? v.id : id;

                    calculatePrice(editedItem)
                  }"
                />
              </v-col>
              <v-col cols="6">
                <base-paginated-select
                  :selected="editedItem.linehaul_products"
                  endpoint="linehaul"
                  multiple
                  :label="$t('linehaul')"
                  item-text="title"
                  selected-item-text="title"
                  @value-change="val => {
                    editedItem.linehaul_products = val;
                    calculatePrice(editedItem)
                  }"
                />
              </v-col>
              <v-col cols="4">
                <base-paginated-select
                  :selected="editedItem.from_country"
                  endpoint="countries"
                  :label="`${$t('from')} ${$t('country')}`"
                  item-text="full_name"
                  selected-item-text="full_name"
                  :rules="rules"
                  @value-change="v => editedItem.from_country = v"
                />
              </v-col>
              <v-col cols="4">
                <base-paginated-select
                  :selected="editedItem.to_country"
                  endpoint="countries"
                  :label="`${$t('to')} ${$t('country')}`"
                  item-text="full_name"
                  selected-item-text="full_name"
                  :rules="rules"
                  @value-change="v => editedItem.to_country = v"
                />
              </v-col>
              <v-col cols="4">
                <base-paginated-select
                  :selected="editedItem.currency"
                  endpoint="currencies"
                  :label="`${$t('currency')}`"
                  item-text="full_name"
                  selected-item-text="full_name"
                  :rules="rules"
                  @value-change="v => {editedItem.currency = v}"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="editedItem.weight_from"
                  :label="`${$t('weight')} ${$t('from')}`"
                  dense
                  type="number"
                  min="0.00"
                  step="0.01"
                  suffix="g"
                  :rules="rules"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="editedItem.weight_to"
                  :label="`${$t('weight')} ${$t('to')}`"
                  dense
                  type="number"
                  min="0.00"
                  step="0.01"
                  suffix="g"
                  :rules="rules"
                />
              </v-col>
              <v-col cols="4">
                <base-paginated-select
                  :selected="editedItem.dimension"
                  endpoint="dimensions"
                  :label="`${$t('dimensions')}`"
                  item-text="name"
                  selected-item-text="name"
                  :rules="rules"
                  @value-change="v => editedItem.dimension = v"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="editedItem.sales_price"
                  :label="$t('sales_price')"
                  dense
                  type="number"
                  min="0.00"
                  step="0.01"
                  suffix=",-"
                  @input="calculatePrice(editedItem)"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="editedItem.sales_price_surcharge"
                  :label="$t('surcharge', { suffix: '' })"
                  dense
                  type="number"
                  min="0.00"
                  step="0.01"
                  suffix=",-"
                  @input="calculatePrice(editedItem)"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="editedItem.sales_price_percentage"
                  :label="$t('surcharge', { suffix: '%' })"
                  dense
                  type="number"
                  min="0.00"
                  step="0.01"
                  suffix="%"
                  @input="calculatePrice(editedItem)"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.cost"
                  disabled
                  :label="$t('cost_price')"
                  dense
                  suffix=",-"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.margin"
                  disabled
                  :label="$t('margin')"
                  dense
                  suffix=",-"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="deleteUpdate"
        >
          {{ $t('delete_update') }}
        </v-btn>        <v-btn
          color="yellow darken-1"
          text
          @click="close"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          :disabled="!editedItem.active_from"
          @click="validate"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { emptyPriceObject } from '@/utils/helpers'
  import { REQUIRED } from '@/utils/rules'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      calculatePrice: {
        type: Function,
        default: (price) => { return price },
      },
      entity: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        editedItem: {},
        menus: {
          active_from: false,
        },
      }
    },
    computed: {
      rules () {
        return [REQUIRED]
      },
    },
    watch: {
      visible: function (val) {
        if (val) {
          const obj = this.entity ? { _method: 'put', ...this.entity } : emptyPriceObject
          this.editedItem = Object.assign({}, obj)
        }
      },
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.$emit('save', { item: { ...this.editedItem } })
        }
      },
      close () {
        this.$emit('close')
      },
      deleteUpdate () {
        this.$emit('delete', this.entity)
      },
    },
  }

</script>
